import PunchesByMonthPage from "./PunchesByMonthPage";

export default {
    list: PunchesByMonthPage
}